import React, { useEffect } from 'react';
import { get } from 'lodash/fp';
import { connect } from 'react-redux';
// @ts-ignore ts-migrate(6142) FIXME: Module '../../../components/Footer' was resolved t... Remove this comment to see the full error message
import { IPage } from '@whitelabel/helpers/types';
import { FooterLarge, FooterSlim } from '../../../components/Footer';
import * as actions from '../../../actions';
import { IUser } from '../../../helpers/types';

interface IFooterProps {
  footertype?: 'slim' | 'large';
  locale: string;
  user?: IUser;
  disclaimer?: IPage;
  getDisclaimer: (...args: any[]) => any;
  hidedisclaimer?: 'true' | 'false';
  hidefooternav?: 'true' | 'false';
}

const Footer = ({
  footertype = 'large',
  locale,
  user,
  disclaimer,
  getDisclaimer,
  hidedisclaimer = 'false',
  hidefooternav,
}: IFooterProps) => {
  useEffect(() => {
    if (footertype === 'large' && !disclaimer && hidedisclaimer === 'false') {
      getDisclaimer();
    }
  }, [locale, disclaimer, getDisclaimer, hidedisclaimer, footertype]);

  return footertype === 'slim' ? (
    <FooterSlim />
  ) : (
    <FooterLarge disclaimer={disclaimer} user={user} hideFooterNav={hidefooternav === 'true'} />
  );
};

const mapStateToProps = (state: any, props: any) => {
  const { locale } = state.intl;
  const disclaimer =
    props.hidedisclaimer === 'true' ? undefined : props.disclaimer || get(`pages.data.${locale}.disclaimer`, state);

  return {
    locale,
    user: state.user.data,
    disclaimer,
  };
};

const mapDispatchToProps = { getDisclaimer: actions.getDisclaimer };

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
